// Generated by scripts/update-seeq-icons.js from src/svg/seeq/dot.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcDot = {
  prefix: 'fak',
  iconName: 'dot' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f905',
    'M71.7 465.9h87v46.1h-87v-46.1zM465.9 465.9h87.1v46.1h-87.1v-46.1zM865.3 465.9h87v46.1h-87v-46.1zM865.3 512h87v46.1h-87v-46.1zM71.7 512h87v46.1h-87v-46.1zM465.9 512h87.1v46.1h-87.1v-46.1z',
  ],
} satisfies IconDefinition;
